import React, { Component } from 'react';
import Filter from '../filter/filter.component';
import { CustomColumns } from '../modal-popover/custom-columns';
import ButtonIcon from '../../button';
import { StatusData } from '../statusdata/status-data.component';
import CustomDropdownButton from '../custom-form/custom-dropdown-button.component';
export class DetailsDashboard extends Component {
    render(){
        const dataDefaultValue={
            "FilterList": [],
            "Operatorlist": [],
            "OptionList": []
        }

        const {data= dataDefaultValue , translation, addAction , removeAction, applyAction,
                firstList, secondList, defaultList, saveAction, createNewAction, 
                viewSearchAction, extractAction, children, isReadAndExtractOnly, isReadAndWrite,
                statusData, activeStatusFilter, dropdownExtract,buttonIcon, extractListLabel, options, onSelect, isCreateButtonHidden
            } =this.props

        const filterProps = {data, translation, addAction , removeAction, applyAction}
        const customColumnsProps = {firstList, secondList, defaultList, saveAction}

        return(
            <div>
                <Filter {...filterProps}  />
                <div className="horizontal-separator"></div>
                {
                    statusData &&
                    <StatusData statusData={statusData} activeStatusFilter={activeStatusFilter} /> 
                }
                <div className="inventory-circuit-btn-container">
                    <div>
                        {isReadAndWrite && !isCreateButtonHidden && <ButtonIcon onClick={createNewAction} iconSize="17px" customClassName="add-new-button btn-solid-color" labelName="Create New"/>}
                    </div>
                    <div className="container-filter-button">
                        <ButtonIcon onClick={viewSearchAction} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search"/>                      
                        <CustomColumns {...customColumnsProps} />
                        {
                            dropdownExtract ?
                            (isReadAndExtractOnly || isReadAndWrite) && <CustomDropdownButton onSelect={onSelect} buttonIcon={buttonIcon} extractListLabel={extractListLabel} options={options}/>
                            :
                            (isReadAndExtractOnly || isReadAndWrite) && <ButtonIcon onClick={extractAction} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Extract List"/>
                        }                       
                    </div>
                </div>                                
                {children} 
            </div>
        )
    }
}